import { Reveal } from "../motion";
import { Eyebrow } from "../CTA";
import { CUSTOMERS, INDUSTRIES } from "../../lib/site";
import { Building2 } from "lucide-react";

const Customers = () => {
  return (
    <section className="relative bg-surface py-24 sm:py-32" data-testid="customers-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="text-center">
          <div className="flex justify-center"><Eyebrow>Our Clients</Eyebrow></div>
          <h2 className="mt-5 font-display text-4xl font-medium tracking-tight text-navy sm:text-5xl">
            Trusted by Leading Industrial Manufacturers
          </h2>
        </div>

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {CUSTOMERS.map((c, i) => (
            <Reveal key={c} delay={(i % 4) * 0.06}>
              <div
                className="group flex h-28 items-center gap-4 rounded-2xl border border-navy/10 bg-white px-6 transition-all duration-300 hover:border-brand/40 hover:shadow-[0_12px_40px_rgba(0,85,255,0.08)]"
                data-testid={`customer-${i}`}
              >
                <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-navy/5 text-navy transition-colors duration-300 group-hover:bg-brand group-hover:text-white">
                  <Building2 className="h-5 w-5" />
                </div>
                <span className="font-display text-lg font-semibold text-navy">{c}</span>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-3">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-steel">Industries served —</span>
          {INDUSTRIES.map((ind) => (
            <span key={ind} className="rounded-full border border-navy/15 px-4 py-1.5 text-sm font-medium text-navy/70">
              {ind}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Customers;
